<div *ngIf="!busy && !connected">
  <!--<div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.bike_shop_name' | translate}} (Retail Express URL):
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="url" placeholder="xxx.retailexpress.com.au" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'general.username' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="username" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'general.password' | translate}}:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="password" id="rtPassword" />
      </div>
    </div>
  </div>-->

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      API Key:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="apiKey"/>
      </div>
    </div>
  </div>

  <!--<div class="row margin-top-8">
    <div class="col-md-4 label">
      Client ID:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="clientID" />
      </div>
    </div>
  </div>-->

  <div class="row margin-top-8">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8">
      <button type="button" (click)="SaveSettings()" class="btn btn-primary" [disabled]="apiKey.length === 0">
        Connect to Citrus Lime
      </button>
    </div>
  </div>

</div>

<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-shopify-defaults [partner]="partner"></app-shopify-defaults>
  <!--  todo (dcorbett) removed (status)="configurationUpdate($event)"-->
</div>

